<template>
  <div class="classification-center">
    <div class="classification-left">
        <!-- <div class="title">+ 增加分类</div> -->
        <div class="addclassification">
         <Button type="primary" @click="addclassification()">+ 增加新分类</Button>
        </div>
        <div class="classification-item" v-for="(item,index) in apiData.producttypeList" :key="index">
            <div class="classification-item-father">
                <div class="title-father">
                  <div class="title-father-tit">分类名：</div>
                    <Input
                      placeholder="分类名称，不超过6个汉字"
                      v-model="item.name"
                      maxlength="6"
                      style="width:100px"
                    />
                </div>
<!--                 <div class="title-father">-->
<!--                  <div class="title-father-tit">描述：</div>-->
<!--                    <Input-->
<!--                      placeholder="请输入"-->
<!--                      v-model="item.tag"-->
<!--                      style="width:150px"-->
<!--                    />-->
<!--                </div>-->
                <div class="title-father">
                  <div class="title-father-tit">排序</div>
                    <Input
                      placeholder="请输入"
                      v-model="item.sort"
                      style="width:80px"
                    />
                </div>
<!--                 <div class="title-father">-->
<!--                  <div class="title-father-tit">大图：</div>-->
<!--                    <div class="upload-Img">-->
<!--                      <div v-if="item.bigImg" class="look-img">-->
<!--                        <img :src="item.bigImg" style="width:40px;height:40px" />-->
<!--                        <div class="demo-upload-list-cover">-->
<!--                          <Icon-->
<!--                            type="ios-trash-outline"-->
<!--                            @click.native="deleteFile('bigImg',index)"-->
<!--                          ></Icon>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                        <template v-else>-->
<!--                            <Upload-->
<!--                                :action="uploadUrl"-->
<!--                                :headers="headers"-->
<!--                                :on-error="uploadErr"-->
<!--                                :on-success="(value) => uploadSuccess('bigImg', value,index)"-->
<!--                                name="file"-->
<!--                                :show-upload-list="false"-->
<!--                            >-->
<!--                                <div class="upload-btn">-->
<!--                                    <Icon-->
<!--                                        type="ios-cloud-upload"-->
<!--                                        size="20"-->
<!--                                        style="color: #3399ff"-->
<!--                                    ></Icon>-->
<!--                                </div>-->
<!--                            </Upload>-->
<!--                        </template>-->
<!--                    </div>-->
<!--                </div>-->
<!--                 <div class="title-father">-->
<!--                  <div class="title-father-tit">小图：</div>-->
<!--                     <div class="upload-Img">-->
<!--                      <div v-if="item.smallImg" class="look-img">-->
<!--                        <img :src="item.smallImg" style="width:40px;height:40px" />-->
<!--                        <div class="demo-upload-list-cover">-->
<!--                          <Icon-->
<!--                            type="ios-trash-outline"-->
<!--                            @click.native="deleteFile('smallImg',index)"-->
<!--                          ></Icon>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                        <template v-else>-->
<!--                            <Upload-->
<!--                                :action="uploadUrl"-->
<!--                                :headers="headers"-->
<!--                                :on-error="uploadErr"-->
<!--                                :on-success="(value) => uploadSuccess('smallImg', value,index)"-->
<!--                                name="file"-->
<!--                                :show-upload-list="false"-->
<!--                            >-->
<!--                                <div class="upload-btn">-->
<!--                                    <Icon-->
<!--                                        type="ios-cloud-upload"-->
<!--                                        size="20"-->
<!--                                        style="color: #3399ff"-->
<!--                                    ></Icon>-->
<!--                                </div>-->
<!--                            </Upload>-->
<!--                        </template>-->
<!--                    </div>-->
<!--                </div>-->
                 <div class="title-father">
                  <div class="title-father-tit">图标：</div>
                    <div class="upload-Img">
                       <div v-if="item.img" class="look-img">
                        <img :src="item.img" style="width:40px;height:40px" />
                        <div class="demo-upload-list-cover">
                          <Icon
                            type="ios-trash-outline"
                            @click.native="deleteFile('img',index)"
                          ></Icon>
                        </div>
                      </div>
                        <template v-else>
                            <Upload
                                :action="uploadUrl"
                                :headers="headers"
                                :on-error="uploadErr"
                                :on-success="(value) => uploadSuccess('img', value,index)"
                                name="file"
                                :show-upload-list="false"
                            >
                                <div class="upload-btn">
                                    <Icon
                                        type="ios-cloud-upload"
                                        size="20"
                                        style="color: #3399ff"
                                    ></Icon>
                                </div>
                            </Upload>
                        </template>
                    </div>

                </div>
                 <div class="title-father">
                    <div  class="title-father-tit">首页展示：</div>
                      <i-switch size="large" :true-value="1" :false-value="0" v-model="item.welShow">
                          <span slot="open">开</span>
                          <span slot="close">关</span>
                      </i-switch>
                  </div>
               <div class="father-right">
                <!-- <img  @click="getSort(index,'up')" src="@/assets/images/arrow_up.png">
                <img  @click="getSort(index,'down')" src="@/assets/images/arrow_down.png">
                <img  @click="editClassification(index)" src="@/assets/images/edit.png"> -->
                <img  @click="saveClassification(item,index)" src="@/assets/images/save.png">
                <img @click="deleteClassification(item,index)" src="@/assets/images/delete.png">
              </div>
            </div>


        </div>
    </div>
    <!-- <div class="effect">
      <div class="title">分类预览</div>
      <div class="effect-center"></div>
    </div> -->
  </div>
</template>

<script>
import {apiProducttypeAll,apiProducttypeList,apiProducttypeDelete,apiProducttypeSave,apiProducttypeUpdate,apiProducttypeMove} from '@/api/classification-manage.js'
export default {
  name: "classification-edit",
  data() {
    return {
      headers: {
        token: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API_URL + "/upload-file",
           // query参数
      query: {},
      // 搜索参数
      search: {},
      diyDom: {},
      diyData: {

      },
      apiData:{
        producttypeList:[],
      }
    };
  },
  methods: {
    //添加父级分类
    addclassification(){
        var obj={
            bigImg:'',
            img:'',
            tag:'',
            id:'',
            levle:1,
            name:'',
            parentId:0,
            smallImg:'',
            sort:'',
            welShow:'0'
        }
        this.apiData.producttypeList.push(obj)

    },
    addSon(item,index){
       var obj={
         bigImg:'',
            img:'',
            id:'',
            levle:2,
            tag:'',
            name:'',
           parentId:item.id,
            smallImg:'',
            sort:'',
            welShow:'0'
        }
         this.apiData.producttypeList[index].children.push(obj)
    },
    // //父级编辑
    // editClassification(index){
    //   this.apiData.producttypeList[index].isEdit=true
    // },
    // //子级编辑
    // editSonClassification(index,idx){
    //   this.apiData.producttypeList[index].children[idx].isEdit=true
    // },
    //保存
    saveClassification(item,index){
      var opt={...item}
        apiProducttypeSave(opt).then(res => {
          this.$Message.success('操作成功');
          this.getProducttypeList()
        });

    },
    //删除
    deleteClassification(item,index,idx){

      if(item.id){
        this.$Modal.confirm({
            title: '提示',
            content: '确认删除当前分类？',
            onOk: () => {
                apiProducttypeDelete({
                    ids: item.id
                }).then(res => {
                    this.$Message.success('操作成功');
                    this.getProducttypeList();
                });
            }
        });
      }else{
        if(item.levle==1){
          this.apiData.producttypeList.splice(index,1)
        }else if(item.levle==2){
          this.apiData.producttypeList[index].children.splice(idx,1)
        }
      }

    },
    getSort(index,type){

      if(type=='up'){
        var opt={
          id1:this.apiData.producttypeList[index-1>0?index-1:0].id,
          id2:this.apiData.producttypeList[index].id,
         }
         console.log(opt,'up')
      }else if(type=='down'){
         var opt={
          id1:this.apiData.producttypeList[index].id,
          id2:this.apiData.producttypeList[index+1>=this.apiData.producttypeList.length?index:index+1].id,
         }
          console.log(opt,'down')
      }
      apiProducttypeMove(opt).then(res => {
        this.getProducttypeList()
      });
    },
    getSonSort(index,idx,type){
      if(type=='up'){
         var opt={
          id1:this.apiData.producttypeList[index].children[idx-1>0?idx-1:0].id,
          id2:this.apiData.producttypeList[index].children[idx].id,
         }
      }else{
          var opt={
          id1:this.apiData.producttypeList[index].children[idx].id,
          id2:this.apiData.producttypeList[index].children[idx+1>=this.apiData.producttypeList[index].children.length?idx:idx+1].id,
         }
      }
      apiProducttypeMove(opt).then(res => {
        this.getProducttypeList()
      });
    },

    getProducttypeList(){
        apiProducttypeList().then(res => {
            var obj=[]
            var list=res.data.list
            for(var i=0;i<list.length;i++){
                if(list[i].level>1){
                  obj=obj.map(item=>{
                        if(item.id==list[i].parentId){
                            var children=list[i]
                            children.isEdit=false
                            item.children.push(children)
                        }
                        return item
                    })

                }else{
                    var data=list[i]
                    data.children=[]
                    data.isEdit=false
                    obj.push(data)
                }

            }
            this.apiData.producttypeList=obj
            console.log(obj)
        });
    },
     uploadSuccess(type, res, index = 0) {
      if (res.code != 200) {
        return this.$Modal.error({ title: "提示", content: res.msg });
      }
      this.$Message.success("文件上传成功");
      // if(type=='img'){
        this.apiData.producttypeList[index][type]=res.data.fileUrl
        console.log(this.apiData.producttypeList[index][type])
      // }

    },
    // 文件上传失败
    uploadErr() {
      this.$Spin.hide();
      this.$Modal.error({
        title: "提示",
        content: "文件上传失败，请重试",
      });
    },
    // 查看文件
    lookFile(url) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.target = "_blank";
      a.href = url;
      a.click();
      document.body.removeChild(a);
    },
    // 删除文件
    deleteFile(type,index) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认删除文件？",
        onOk: () => {
         this.apiData.producttypeList[index][type]=''

        },
      });
    },

  },
  mounted() {
   this.getProducttypeList()
  },
};
</script>

<style scoped lang="less">
.max-w200{
    max-width: 200px;
    width: 100%;
}
.classification-center {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .classification-left {
    width:100%;
    background: #fff;
    padding: 40px;
    box-sizing: border-box;
    margin-right: 20px;
    .title{
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 26.06px;
        color: rgba(56, 56, 56, 1);
        text-align: left;
        margin-bottom: 15px;
    }
    .classification-item{
        width: 100%;
        margin-top: 20px;
        background: rgba(229, 229, 229, 0.5);
        padding: 10px 20px;
        box-sizing: border-box;
        .classification-item-father{
            width: 100%;

            display: flex;
            align-items: center;
            .title-father{
                 font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 23.17px;
                color: rgba(0, 0, 0, 1);
                display: flex;
                align-items: center;
                 margin-right: 10px;
            }
            .classification-item-addSon{
                width: 80px;
                height: 24px;
                opacity: 1;
                border-radius: 2px;
                background: rgba(0, 0, 0, 0.15);
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(0, 0, 0, 0.65);
                text-align: center;
                border: 1px solid #000000;
                 cursor: pointer;
            }
            .father-right{
               img{
                width: 16px;
                height: 16px;
                margin-left: 20px;
                display: block;
                cursor: pointer;
            }
            }


        }
      .father-right{
        display: flex;
        align-items: center;
      }
        .classification-item-son{
                width: 100%;
        display: flex;
        margin-top: 20px;
        align-items: center;

        .title-son{
                padding-left: 15px;
        box-sizing: border-box;
        width: 310px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(0, 0, 0, 1);
        text-align: left;
        display: flex;
         margin-right: 20px;
        .line{
            width: 20px;
            height: 20px;
            position: relative;
            margin-top: -10px;
            border-left:1px solid #000000 ;
            border-bottom:1px solid #000000 ;
            margin-right: 20px;
        }
        }
         img{
                width: 16px;
                height: 16px;
                margin-right: 20px;
                display: block;
                cursor: pointer;
            }
        }

    }
  }
}
.title-father-tit{
  font-size: 14px;
}
.upload-Img{
width: 40px;
    height: 40px;
    .upload-btn{
    background: #F7F8FA;
    width: 40px;
    height: 40px;
    padding-top: 5px;
}
}
.look-img{
  margin-left: 0px;
  width: 40px;
  height: 40px;
  img{
    margin-left: 0px;
  }

}
 .upload-Img .demo-upload-list-cover i{
    line-height: 40px !important;
  }
</style>
